<template>

  <section id="privacypolicy">
  <div class="home container-main">
    <my-header></my-header>
    <div class="container">
      <div class="is-size-2" style="padding-bottom: 20px">PRIVACY POLICY</div>
      <div class="text-left">
        <ol>
          <li>
            <b>INTRODUCTION</b>
            <br />
            <p>
              <b>Gigforce Private Limited,</b> a company incorporated under the
              Companies Act, 2013 vide CIN - U74999HR2019PTC082217, having its
              corporate office at House no 1872 Sector-2 BALLABHGARH Faridabad
              HR 121004 IN hereinafter referred to as the “<b>Company</b>” or
              “<b>We</b>” (which expression shall, unless it be repugnant to the
              context or meaning thereof, include its successors and assigns)
              owns and operates
              <a href="https://www.gigforce.in/"><u> www.gig4ce.com </u></a>
              (“<b>Website</b>”) and our application gig4ce (jointly referred to
              as “<b>Platform</b>”). Subject to the terms and conditions and
              user agreement set out on the Platform which shall be read along
              with this privacy policy (“<b>Privacy Policy</b>”), the Company
              shall make available through the Platform being an online
              aggregator platform and connecting medium for (i) persons to
              provide their work profiles, availability status and interest
              areas for rendering services in specific areas in time bound
              manner (“<b>Independent Consultants</b>” or “<b>IC</b>”); (ii) for
              corporate entities to provide their requirements of availing
              services of IC’s on specific assignments (“<b>Work Assignments</b
              >”) in regard to their business establishment (“<b
                >Requirement Listing Companies</b
              >”); (iii) third party service provider entities who are
              interested in rendering services including skill improvement
              seminars, e-workshops for enhancing professional skills,
              preparation of IC’s for interview and finalising of their work
              profile, insurances and social security, payroll services, pay
              roll compliance services, staffing service providers, legal and
              account related services etc. (“<b
                >Third Party Service Providers</b
              >”) in consideration of the subscription fee which may be fixed by
              the Company from time to time and reflected on the Platform while
              availing the services and as may be amended by the Company at its
              sole discretion from time to time (“<b>Subscription Fees</b>”) on
              the terms and conditions set out in the terms and conditions and
              user agreement on the Platform (“<b>Services”</b>). It is
              expressly clarified that the Company may render certain specific
              Services without any charges for a specific time period as may be
              deemed fit by the Company and which shall be notified on the
              Platform from time to time.
            </p>
            <br />
            <p>
              The terms and conditions, user agreement and the Privacy Policy
              shall together constitute the Agreement which the User will
              execute with the Company and shall always be read together for any
              purpose associated with the Services.
            </p>
            <br />
            <p>
              We understand the importance of protecting your privacy. We are
              committed to safeguarding the privacy of the personal identifiable
              information that We collect, possess, use, process, record, store,
              transfer, disclose, deal, handle and receive, by and on behalf of
              our Users (as defined under the Terms and Conditions set out on
              the Platform) while rendering Services to our Users through the
              Platform. Accordingly, set out below is our Privacy Policy setting
              out how we intend to safeguard such personal identifiable
              information received and used by us as aforesaid. This is in
              compliance with the prevailing Information Technology Act, 2000
              and the Information Technology (Reasonable Security Practices And
              Procedures And Sensitive Personal Data Or Information) Rules, 2011
              under the Information Technology Act, 2000 (“<b>IT Act</b>”).
            </p>
            <br />
            <p>
              The Company understands the importance of protecting the User’s
              privacy and is committed to safeguarding the privacy of the
              Sensitive Personal Information or Data that it collects,
              possesses, uses, processes, records, stores, transfers, discloses,
              deals with, handle and receives, by and on behalf of the User’s
              while rendering Services to the User’s. The Company intends to
              provide utmost security in respect to the Sensitive Personal
              Information or Data provided by the User and has complied with
              reasonable security practices and procedures.
            </p>
          </li>
          <br />
          <li>
            <b>SCOPE AND APPLICABILITY OF THIS POLICY</b>
            <br />
            <p>
              This privacy policy, as amended from time to time, ( “<b
                >Privacy Policy</b
              >”) is effective from <b>1st April, 2020</b> and applies to the
              Company, its affiliates and group companies, its employees, staff,
              team members, consultants, contractors, advisors, accountants,
              agents, person, representatives of the Company and/or service
              providers who collect, possess, use, process, record, store,
              transfer, disclose, deal, handle and receive, the personal
              identifiable information by and on behalf of the Users
              (“<b>You</b>” or “<b>Your</b>”) while rendering Services.
            </p>
            <p>
              This Policy summarizes what type of Personal Identifiable
              Information or PII (as defined hereinafter) which We collect about
              You, the purpose of such data collection, storage and usage of
              such data or information, to whom such data or information may be
              disclosed/transferred and how We protect Your privacy.
            </p>
          </li>
          <br />
          <li>
            <b>TYPES OF PERSONAL DATA OR INFORMATION WE COLLECT</b>
            <br />
            <p>
              The term “<b>Personal Identifiable Information or PII</b>” in this
              Policy refers to personal information which does and/or is capable
              of identifying You as an individual including sensitive personal
              data. The types of Personal Identifiable Information that We
              collect consist of personal and financial information relating to
              You:
            </p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  name, gender, home address, telephone number, date of birth,
                  marital status, email address, emergency contacts or other
                  contact information (including the gender, age, nationality
                  and passport information of any relatives and beneficiaries);
                  or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  affiliations, interests, work history, technical skills,
                  educational background, professional certifications and
                  registrations, language capabilities, or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  voicemails, e-mails, password, correspondence and
                  communications; or
                </p>
              </li>
              <li><p style="margin-left: 30px">password; or</p></li>
              <li>
                <p style="margin-left: 30px">
                  financial information such as Bank account or credit card or
                  debit card or other payment instrument details; or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  physical, physiological and mental health condition; or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">medical records and history; or</p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  biometric information; or location of the User in the event,
                  the User given access to the same.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  any detail relating to the above clauses as provided to the
                  Company; or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  any of the information received under above clauses by the
                  Company for collecting, receiving, possessing, using,
                  processing, recording, storing, transferring, dealing,
                  handling and disclosing under lawful contract or otherwise.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  access to some of Your financial information as may be
                  provided by You for the purpose of accessing the Platform.
                  These information may include information which may also be in
                  the nature of being KYC information or personal financial
                  information which may be provided by the You, third party
                  API's or RTA feed etc., and received by the company. Wherever
                  such financial information is of the nature that even if
                  disclosed in isolation it will result in identification of the
                  person to whom such data pertains, it shall qualify as
                  Personal Identifiable Information and be classified as
                  Personal Identifiable Information and be treated in the same
                  manner and at the same standard as Personal Identifiable
                  Information is treated as per this Privacy Policy.
                </p>
              </li>
            </ul>
            <br />
            <p>
              This Policy does not apply to any information that You may
              disclose publicly and which is freely available or accessible in
              public domain or furnished under the Right to Information Act,
              2005 or any other law for the time being in force and such
              information shall not be regarded as Personal Identifiable
              Information for the purposes of this Policy. Further, Your
              Personal Identifiable Information shall not be disclosed to any
              third person unless the said third person is required to have the
              Personal Identifiable Information of Yours to provide required
              Services to You and/or with Your permission and/or to help
              investigate, prevent or take action regarding unlawful and illegal
              activities, suspected fraud, potential threat to the safety or
              security of any person, violations of the terms and conditions of
              use of the Platform or to defend against legal claims and special
              circumstances such as compliance with the rules of any stock
              exchange, subpoenas, court orders, requests/order from legal
              authorities or law enforcement agencies requiring such disclosure.
              We share Your information with advertisers on an aggregate basis
              only.
            </p>
            <br />
            <p>
              Further, any Personal Identifiable Information disclosed by the
              Users while connecting with each other through the Platform, the
              Company shall not be responsible and/or liable to treat the same
              as the Personal Identifiable Information to be protected by the
              Company.
            </p>
          </li>
          <br />
          <li>
            <b>YOUR CONSENT</b>
            <br />
            <p>
              You are providing Your consent by providing Your details at the
              time of registration on the Platform (“<b>Consent</b>”) with
              respect to the purpose of usage of such Personal Identifiable
              Information.
            </p>
            <br />
            <p>
              If You give Your Consent, it is construed that You have done so
              freely and voluntarily and agree to this Policy. You always have
              the right to refuse or withdraw Your Consent for the Personal
              Identifiable Information sought to be collected or withdraw Your
              Consent given earlier to us. We will always respect such a refusal
              or withdrawal, but this could affect Your use of Platform and We
              being unable to perform all the Services, arrangements or
              contracts with You and will have the option to discontinue the
              same. We will inform You of these inabilities, if they occur.
              However, We reserve the right to retain such Personal Identifiable
              Information as may be necessary for providing our pending Services
              to You and in accordance with this Policy and/or if legally
              required.
            </p>
            <br />
            <p>You are aware of the:</p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  fact that the Personal Identifiable Information is being
                  collected;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  contents and/or type of Personal Identifiable Information
                  which is being collected;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  purpose for which the Personal Identifiable Information is
                  being collected;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  intended recipients of the Personal Identifiable Information;
                  and
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  name and address of the agency that is collecting the Personal
                  Identifiable Information o, processing the said Personal
                  Identifiable Information and retaining the same.
                </p>
              </li>
            </ul>
            <br />
            <p>
              We respect Your privacy, therefore, the Company will observe the
              following guidelines when collecting, receiving, possessing,
              using, processing, recording, storing, transferring, dealing,
              handling, and disclosing:
            </p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be collected, received,
                  possessed, used, processed, recorded, stored, transferred,
                  dealt, handled and disclosed in compliance with the local
                  laws/regulations in India including IT Act and the rules
                  framed under the same;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be relevant/necessary
                  to/for the purposes for which it is collected and used;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be current and accurate
                  with reasonable steps taken by the Company to rectify or
                  delete inaccurate Personal Identifiable Information;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be kept only as long as
                  necessary for the purposes for which it was collected and
                  processed; and
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Reasonable measures will be taken to prevent unauthorized
                  access or use, unlawful processing, and unauthorized or
                  accidental loss, destruction, or damage to such Personal
                  Identifiable Information.
                </p>
              </li>
            </ul>
          </li>
          <br />
          <li>
            <b
              >PURPOSES FOR COLLECTION, STORAGE AND/OR USE OF PERSONAL DATA OR
              INFORMATION</b
            >
            <br />
            <p>
              The primary purposes for collection, storage and/or use of
              Personal Identifiable Information is for:
            </p>
            <!-- <br /> -->

            <ul>
              <li>
                <p style="margin-left: 30px">
                  our business processes, operations and management including
                  but not limited to performance of the business, operation of
                  the Services, entering into or performing any contract,
                  maintaining quality of the Services, providing support to the
                  Services You have obtained from us, managing company assets;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  processing Your order, corresponding with You, fulfilling Your
                  transaction requests and delivering the programs, information,
                  and Services requested by You or other Services related
                  inquiries;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  managing Client contacts profiles, administering and providing
                  You with information, services that You request from us or
                  which We feel may interest You,
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  record keeping and other general administrative and Services
                  related processes;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  ensuring the safety and protection of the rights or property
                  of the Company or its business;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  complying with applicable legal requirements in India
                  including but not limited to governmental reporting, etc. and
                  fulfilling statutory/legal obligations as a service provider
                  under applicable laws, adhering to judicial or administrative
                  orders, compliance with laws;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  contacting You via surveys to conduct research about Your
                  opinion of current Services or of potential new services that
                  may be offered by us;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  monitoring or recording of certain calls, chats and other
                  interactions relating to the online transactions which may
                  involve You calling us or us calling You and online chats for
                  staff training or quality assurance purposes or to retain
                  evidence of a particular transaction or interaction;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  while conducting daily business/operations such Personal
                  Identifiable Information may be provided to affiliates and
                  group companies, employees/staff of the Company and third
                  party's for the purpose of processing such Personal
                  Identifiable Information for or on our behalf including but
                  not limited to helping us to perform statistical analysis,
                  send You email or postal mail, provide clients and/or
                  prospective clients the support/support services, arrange for
                  deliveries of programs, information, and services, etc.;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  operating Platform, improving the content of our Platform to
                  offer You better Services and to ensure that content from our
                  Platform is presented in the most effective manner for You;
                  and in connection with the business of the Company.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  To personalize Your experience and provide content and Service
                  offerings that are best suited to Your interests;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  To allow us to better respond to Your specific service
                  requests;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">To improve our Services;</p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  To overall analyze and understand Your behaviour by use of
                  data analytics to better Your experience and provide content
                  and Service offerings that are best suited to Your interests.
                  However, the results of which shall be considered our sole
                  intellectual property and proprietary know-how, and shall not
                  by virtue of use of Your data for the purpose of such analysis
                  grant any right of ownership of the end product to either You
                  or any of Your heirs or assigns or to any other third party.
                </p>
              </li>
            </ul>
            <br />
            <p>
              We shall, at all times, store Your Personal Identifiable
              Information in our cloud server storage (hosted and operated by
              external vendor such Google and Amazon) and to the best of our
              knowledge We understands that our external cloud storage vendors
              shall make best endeavor to ensure that such Personal Identifiable
              Information is safely stored clouds storages and shall be used for
              the purpose of business transactions only and shall be further
              protected and secured in compliance with the reasonable security
              practices and procedures.
            </p>
          </li>
          <br />
          <li>
            <b>DATA COLLECTION DEVICES</b>
            <br />
            <p>
              In addition to Personal Identifiable Information, We may use data
              collection devices such as “<b>cookies</b>” or other technology to
              obtain certain types of information when Your web browser accesses
              our Platform. Cookies are small files containing a string of
              characters to identify Your browser. Cookies allow the Platform to
              remember important data or information that will make Your visit
              to the Platform more useful. Our Platform may use cookies, web
              beacons and other similar invasive technology to store pertinent
              user information during a session to speed navigation and keep
              track of items and to collect anonymous traffic data that We may
              use to enhance our Platform and for marketing and promotional
              purposes. You can reset Your browser to refuse cookies or warn You
              when they are being sent. Please note that by turning cookies off,
              You may not have access to all features available on our Platform.
              We also use logging systems on our internal network to register
              the use of our computer systems. This is done for the purpose of
              ensuring the performance, integrity and security of these systems.
              We may also contract with third party’s to track and analyze
              anonymous usage and volume statistical information from our
              visitors and members for research purposes. Such information is
              shared externally only on an anonymous, aggregated basis. Such
              third party's use persistent cookies to help us to improve the
              visitor experience, to manage our Platform content, and to track
              visitor behaviour. All data or information collected by the
              Company is used solely by or on behalf of the Company and is
              shared externally only on an anonymous, aggregated basis.
            </p>
            <br />
            <p>
              We will make best efforts to do so but do not warrant that any of
              the third party platforms or any affiliate site(s) or network
              system linked to our Platform is free of any operational errors
              nor do We warrant that our Platform will be free of any virus,
              computer contaminant, worm, or other harmful components. Our
              Platform contains links to other sites which are not owned or
              operated by the Company. The Company is not responsible and makes
              no guarantee for the privacy practices or the content of such
              third party platforms. These links are provided only as a
              convenience to You. Neither, the Company nor any of its affiliates
              are responsible for the availability of such third party platforms
              or their contents. The Company will not be liable for Your
              Personal Identifiable Information transmitted over networks
              accessed by You on these sites or otherwise connected with Your
              use of the services. You understand, acknowledge and agree that
              neither the Company nor any of its affiliates are responsible or
              liable, directly or indirectly, for any damage or loss of any sort
              caused in connection with your use of or reliance on any content
              of any such site or services available through any such site.
            </p>
            <br />
            <p>
              You acknowledge that the Services, content, site and/ or any
              software are provided on an “<b>as is</b>” and “<b>as available</b
              >” basis, without warranties of any kind, either express or
              implied, including, without limitation, implied warranties of
              merchantability, fitness for a particular purpose. Although the
              Company has taken adequate safeguard and in case of any breach the
              Company may take action to remedy such breach. In addition to
              taking all the reasonable precautions as required under law, the
              Company expressly disclaims any and all warranties, express or
              implied, including, without limitation: (i) The Services and/ or
              software will be free of all viruses and hacking. (ii)The software
              will work on all mobile phones, will be compatible with all mobile
              phone networks and/or will be available in all geographical areas.
              (iii) Any service will be uninterrupted, timely, secure or
              error-free for any reasons whatsoever including but not limited to
              overload/breakdown of receiving network, servers or applications;
              system failures out of the Company’s control or due to heavy
              traffic on network.
            </p>
          </li>
          <br />
          <li>
            <b>DISCLOSURES OR TRANSFER OF YOUR PERSONAL DATA OR INFORMATION</b>
            <br />
            <p>
              The Company will transfer, with Your Consent, the Personal
              Identifiable Information to any other third party in India or
              overseas, that ensures the same level of data protection that is
              adhered to by the Company as set out herein for fulfilling any
              contractual obligation.
            </p>
            <br />
            <p>
              We will disclose or transfer Your Personal Identifiable
              Information in accordance with this Policy and all applicable
              legal requirements as applicable in India.
            </p>
            <br />
            <p>
              Your Personal Identifiable Information will be disclosed or
              transferred, as may be required from time to time, as follows:
            </p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  <b>For Business Purposes:</b>
                  to (i) the appropriate employees/staff/persons in our offices;
                  (ii) our affiliates and group companies; (iii) from one office
                  within the Company to another office in India or overseas in
                  accordance with the IT Act; (iv) to any third party, in the
                  event of a proposed or actual business transfer; (v) to the
                  Requirement Listing Companies, (vi) to Third Party Service
                  Providers, (vi) certified third party verification agencies
                  for the purpose of background and document verification at the
                  time of registration and (vii) in connection with our business
                  and Services provided by the Company.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  <b>To third party's:</b>
                  working with us or on our behalf in different industries and
                  categories of business. We will disclose, share, transfer Your
                  Personal Identifiable Information to any third party or
                  provide Your Personal Identifiable Information to any third
                  party in connection with our business requirements or for the
                  purposes indicated herein. Such third party's are required to
                  process Your Personal Identifiable Information they receive
                  from us in a lawful, safe and responsible manner in accordance
                  with this Policy and the prevailing laws and take all
                  appropriate security and confidentiality measures such that
                  they do not use Your Personal Identifiable Information for
                  their own purposes or disclose Your Personal Identifiable
                  Information or PII to others. Neither the Company nor any
                  third party will publish Your Personal Identifiable
                  Information.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  <b>For Legal Requirement:</b>
                  to any court of law and/or government agencies/entity as may
                  be required under law and/or statutory authority, Reserve Bank
                  of India and Credit Information Bureau India Ltd.
                  (“<b>CIBIL</b>”) or in response to a legal process, for the
                  purpose of verification of identity, or for prevention,
                  detection, investigation including cyber incidents,
                  prosecution, and punishment of offences and/or to any third
                  party by an order under the applicable law or if We determine
                  it is necessary or desirable to comply with any applicable
                  law, regulation, legal process or enforceable governmental
                  request or to protect or defend our rights or property
                  including compliance with accounting and tax rules and
                  regulations or to investigate, detect, prevent, or take action
                  regarding illegal activities, suspected fraud, security or
                  technical issues or situations involving potential threats to
                  the physical safety of any person.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  <b>For Centralized Data Processing Activities:</b>
                  We have centralized certain aspects of our data processing and
                  administration in order to allow us to better manage our
                  business. Such centralization may result in the transfer of
                  Your Personal Identifiable Information: (i) from one country
                  to another; (ii) to our employees/staff of the
                  affiliates/group companies of the Company in other locations,
                  etc. However, whenever Your Personal Identifiable Information
                  or PII is transferred within the Company, it will be processed
                  in accordance with the terms and conditions of this Policy.
                </p>
              </li>
            </ul>
          </li>
          <br />
          <li>
            <b>REASONABLE SECURITY PRACTICES AND PROCEDURES AND AUDITS</b>
            <br />
            <p>
              We seek to ensure compliance with the requirements of the IT Act
              to ensure the protection and preservation of Your privacy,
              therefore We take reasonable security measures to protect Your
              Personal Identifiable Information against unauthorized access,
              alteration, disclosure or destruction. We have a number of
              physical, electronic, and procedural safeguards/measures in place
              to actively protect the confidentiality, security, and integrity
              of Your Personal Identifiable Information, including a
              comprehensively documented information security programme and a
              strict security policy that contains managerial, technical,
              operational and physical security control measures for protecting
              such data or information. We have implemented standard or code of
              best practices for data or information protection.
            </p>
            <br />
            <p>
              We limit access to Your Personal Identifiable Information to
              members of our team/employees of the Company/third party's who We
              believe reasonably need to come into contact with that information
              for the purpose of performing their duties and rendering services
              to You. We have strict confidentiality obligations that apply to
              such members/employees of the Company/third party's. Failure to
              meet these obligations may result in disciplinary and other
              actions, including dissolution of a contract, termination of
              employment and criminal prosecution.
            </p>
            <br />
            <p>
              We conduct training to authorized users regarding the lawful and
              intended purposes of processing Your Personal Identifiable
              Information , the need to protect and keep information accurate
              and upto-date and the need to maintain the confidentiality of the
              data or information to which such authorized users have access.
              Authorized users will comply with this Policy, and We will take
              appropriate disciplinary actions, in accordance with applicable
              laws in India, if Your Personal Identifiable Information is
              accessed, processed, or used in any way that is inconsistent with
              the requirements of this Policy.
            </p>
          </li>
          <br />
          <li>
            <b>RETENTION OF YOUR PERSONAL DATA OR INFORMATION</b>
            <br />
            <p>
              We are aware of the importance of timely destruction of Personal
              Identifiable Information. We ensure that Your Personal
              Identifiable Information is not stored/retained for a longer
              period than necessary for the purpose for which it was collected,
              used or processed or as provided in our contracts except when
              there is a legal obligation to do so under any law in India. It is
              our practice to destroy Your Personal Identifiable Information as
              soon as possible after it is no longer necessary for the purpose
              for which it was collected, used or processed save and except as
              stated hereinabove.
            </p>
          </li>
          <br />
          <li>
            <b
              >UPDATING OR REVIEWING YOUR PERSONAL DATA OR INFORMATION/
              QUESTIONS OR COMPLAINTS</b
            >
            <br />
            <p>
              You may by a written request review the Personal Identifiable
              Information provided by You. We will ensure that any Personal
              Identifiable Information about You which is found to be inaccurate
              or deficient shall be corrected or amended as may be feasible.
            </p>
            <br />
            <p>
              You expressly state that Personal Identifiable Information
              provided by You to us is correct and complete in all respects and
              does not contain any false, distorted, manipulated, fraudulent or
              misleading facts. We expressly disclaim any liability arising out
              of the said data or information provided by You to us. Further,
              You expressly agree that We are not responsible for the accuracy
              and authenticity of such data or information provided by You to us
              and You agree to indemnify the Company for all losses incurred by
              the Company due to any false, distorted, manipulated, defamatory,
              libelous, vulgar, obscene, fraudulent or misleading facts made by
              You to the Company.
            </p>
            <br />
            <p>
              In case of any discrepancies or grievances with regard to the
              processing of Your Personal Identifiable Information, please
              contact the “<b>Grievance Officer – Anirudh Syal</b>” at
              <a href="mailto:complaints@gig4ce.com"
                ><u> complaints@gig4ce.com </u></a
              >. Further on receipt of any concerns or complaints the Grievance
              Officer will employ all commercially reasonable efforts to address
              the same within One (1) month of receipt of same.
            </p>
          </li>
          <br />
          <li>
            <b>ENFORCEMENT RIGHTS</b>
            <br />
            <p>
              All the Company’s affiliates/group companies will ensure that this
              Policy is observed. All employees/staff of the Company and Third
              Parties who have access to Personal Identifiable Information are
              required to comply with this Policy.
            </p>
            <br />
            <p>
              All third party's shall only process the Personal Identifiable
              Information in accordance with the Company's instructions or make
              decisions regarding such data or information as part of the
              delivery of their services. In either instance, the Company will
              select reliable third parties who undertake, by contract or other
              legally binding and permissible means, to put in place appropriate
              technical and organizational security measures to ensure an
              adequate level of protection of such data or information. The
              Company will require third party's to comply with this Policy or
              to guarantee the same levels of data protection that is adhered to
              by the Company when handling/processing such data or information.
              Such selected Third Party's will have access to such data or
              information solely for the purposes of performing the services
              specified in the applicable service contract and are legally and
              contractually bound to maintain the privacy of such data or
              information shared with them and will not disclose it further. If
              the Company concludes that a third party is not complying with
              these obligations, it will promptly take appropriate actions to
              remedy such non-compliance or implement necessary sanctions.
            </p>
            <br />
            <p>
              Additionally, our team members/employees/staff are bound by
              internal confidentiality standards and policies. Any team
              member/employee/staff found to have violated this Policy or any
              other policies will be subject to strict disciplinary action, up
              to and including termination of employment including penalties
              under applicable laws in India.
            </p>
            <br />
            <p>
              All third parties and our team members/employees/staff do hereby
              specifically agree that he/she/it shall, at all times, comply with
              the requirements of the IT Act, while collecting, receiving,
              possessing, using, processing, recording, storing, transferring,
              dealing, handling and disclosing Personal Identifiable
              Information. The said third parties and team
              members/employees/staff do further unequivocally declare that in
              case he/she/it violates any provisions of the IT Act, he/she/it
              shall alone be responsible for all his/her/it acts, deeds and
              things and that he/she/it alone shall be liable for civil and
              criminal liability there under or under any applicable Indian law
              for the time being in force.
            </p>
          </li>
          <br />
          <li>
            <b>MODIFICATIONS TO THE POLICY</b>
            <br />
            <p>
              The Company reserves the right to update, change or modify this
              Policy, from time to time, without prior notification. The Policy
              shall come into effect from the date of such update, change or
              modification.
            </p>
            <br />
            <p>
              We will inform You regarding any such changes by updating this
              Policy and will post all changes to the Policy on relevant place
              on the Platforms.
            </p>
            <br />
            <p>
              Effective with the implementation of this Policy, all existing
              intra-group agreements and the applicable Company privacy
              guidelines or practices relating to the processing of Personal
              Identifiable Information will be superseded by the terms of this
              Policy and modified accordingly. All parties to any such
              agreements will be notified of the effective date of
              implementation of the Policy.
            </p>
            <br />
            <p>
              If any of the terms or definitions used in this Policy are
              ambiguous, the definitions established under the IT Act and the
              rules formulated under the scheme of the IT Act, shall apply.
            </p>
          </li>
        </ol>
        <br />
      </div>
    </div>

    <my-footer></my-footer>
  </div>
  </section>
</template>

<script>
import header from "../components/Header";
import footer from "../components/Footer";

export default {
  methods: {},
  mounted() {},
  components: {
    myFooter: footer,
    myHeader: header,
  },
};
</script>

<style lang="scss">
.home {
  font-family: "Poppins", sans-serif;
  color: rgb(24, 24, 24);
  overflow-x: hidden;
  margin-top: 8%;
}
ul {
  list-style: disc;
  margin-left: 10px;
}

.pointer {
  cursor: pointer;
}
.home-container {
  width: 80%;
  margin: 0 auto;
}

.text-left {
  text-align: left;
}
</style>